import React,{Component} from 'react';
import TextField from "@material-ui/core/TextField";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Link } from 'react-router-dom';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import SimpleReactValidator from "simple-react-validator";
import Api from "../../../libraries/api";
import Button from '@material-ui/core/Button';
import {toast, ToastContainer} from "react-toastify";
import {history} from "../../../shared/configure-store";
import AuthHelper from "../../../libraries/auth-helper";

require('dotenv').config();
const validator = new SimpleReactValidator();

class BlogAdd extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            loadingImage: false,
            errors: {},

            editorState: '',

            id: '',
            title: '',
            content: '',
            slug: '',
            photo: null,
            image: '',
            excerpt: '',
            tags: [],

            categories: [],
            test: '{"blocks":[{"key":"fh119","text":"dfsfdsfs fsdfsd","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":9,"length":6,"style":"BOLD"}],"entityRanges":[],"data":{}}],"entityMap":{}}',

            isManage: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Gudangemas - Tambah Blog';

        let profile = AuthHelper.getProfile();
        if(profile['map-menu']) {
            let roles = profile['map-menu'].map(o => {
                return {
                    id: o.id,
                    name: o.menu.name,
                    isCreate: o.isCreate,
                    isManage: o.isManage,
                }
            });

            let all = roles.filter((item) => item.name === 'Blog');

            if (all.length > 0) {
                this.setState({
                    isManage: all[0] ? all[0].isManage : false
                });
            }
        }

        let params = {
            page: 0,
            size: 50,
        };
        Api.post('/blog-page/get-all-category', params).then(resp => {

            if (resp.data.blogPageCategories) {
                let data = resp.data.blogPageCategories.map(o=>{
                    return {
                        label: o.name,
                        value: o.id,
                    }
                });
                this.setState({
                    categories: data,
                        loading: false
                    }
                );            }

        }).catch(err => {
            console.log(err);
        });

    }

    handleChange (e, prop){
        if(prop === 'title') {

            this.setState({
                slug: this.convertToSlug(e.target.value)
            })
        }

        this.setState({

            [prop]: e.target.value

        })

    };

    convertToSlug(Text) {
        return Text
            .toLowerCase()
            .replace(/ /g,'-')
            .replace(/[^\w-]+/g,'')
            ;
    }

    onEditorStateChange = (editorState) => {
        console.log(editorState)
        this.setState({
            editorState,
        });
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleSubmit = (e) => {

        e.preventDefault();

        if (!validator.allValid()) {

            this.setState({
                    errors: validator.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loadingButton: true,
            }
        );

        let text = '';
        if(this.state.editorState) {
            text = JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent()))
        }

        let data = this.state.tags.map(o=>{
            return {
                id: o.value,
                'is-check': true,
            }
        });

        let params = {
            'title': this.state.title,
            'content': text,
            'slug': this.state.slug,
            'image': this.state.image,
            'excerpt': this.state.excerpt,
            'is-blog': true,
            'is-editor': false,
            'categories': data,
        };

        Api.post('/blog-page', params).then(resp => {

            if(resp.status === 200) {
                history.push('/blogs');
                this.showMessage(true, 'Blog berhasil dibuat');
            }else {
                this.showMessage(false, resp.message[0]);
            }
            this.setState({
                    loadingButton: false,
                }
            );

        }).catch(err => {
            this.setState({
                    errors: err.errors,
                    loadingButton: false
                }
            );
        });


    };


    handleAvatar = e => {
        let idCardBase64 = '';
        let url = e.target.files[0];
        this.setState({
            loadingImage: true,
        });

        this.getBase64(e.target.files[0], (result) => {
            idCardBase64 = result;
        });

        setTimeout(
            () => this.setState({
                image: idCardBase64,
                photo: URL.createObjectURL(url),
                loadingImage: false,
            }),
            3000
        );
    };

    handleGo  = (link) => {

        history.push(link);
    };

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    handleDeleteAvatar = () => {

        this.setState({
            photo: '',
            image: null
        });
    };

    handleDelete = (chipToDelete) => () => {
        let data = this.state.categories.filter((chip) => chip.id !== chipToDelete.id);
        this.setState({
            categories: data,
        })
    };

    onTagsChange = (event, values) => {
        this.setState({
            tags: values
        }, () => {
            // This will output an array of objects
            // given by Autocompelte options property.
            console.log(this.state.tags);
        });
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Blog</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/blogs" >Blog</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Buat</li>
                        </ol>
                    </nav>

                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>Buat Blog</h2>
                            </div>
                        </div>
                        <h3 className='section-title'> </h3>

                        <form name="blog" id="addBlog" className="row" noValidate>
                            <div className="col-12">
                                <div className="form-group slug-group">
                                    <i className="fas fa-link"> </i>
                                    <span>{process.env.REACT_APP_APP_WEB}/blog/</span>
                                    <input className='input-link' type='text'
                                           onChange={(e) => this.handleChange(e, 'title')}
                                           value={this.state.slug}
                                    />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="form-group">
                                    <label>Title</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='title'
                                               name="title"
                                               label="Title"
                                               onChange={(e) => this.handleChange(e, 'title')}
                                               value={this.state.title}
                                               fullWidth
                                    />
                                    {validator.message('title', this.state.title, 'required')}
                                    <div className='text-danger'>{this.state.errors.title}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className='d-block'>Featured Image</label>

                                    {this.state.photo &&
                                    <img src={this.state.photo} alt="user" className="img-thumbnail mr-2" />
                                    }
                                    <TextField variant="outlined"
                                               type="file"
                                               id='avatar'
                                               name="avatar"
                                               className="avatar"
                                               onChange={this.handleAvatar}
                                    />
                                    <label htmlFor="avatar" className="label-file mr-2">Upload Foto {this.state.loadingImage && <i className="fa fa-spinner fa-spin"> </i>}</label>
                                    <button className='btn-delete' type='button' onClick={this.handleDeleteAvatar}>
                                        Hapus Foto
                                    </button>
                                    <div className='text-danger'>{this.state.errors.avatar}</div>

                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="form-group">
                                    <label className='d-block'>Kategori</label>

                                    <Autocomplete
                                        multiple
                                        id="tags-standard"
                                        onChange={this.onTagsChange}
                                        options={this.state.categories}
                                        getOptionLabel={(option) => option.label}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                label="Kategori"
                                                placeholder="Kategori"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="form-group">
                                    <label className='d-block'>Excerpt</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='excerpt'
                                               name="excerpt"
                                               label="Excerpt"
                                               onChange={(e) => this.handleChange(e, 'excerpt')}
                                               value={this.state.excerpt}
                                               fullWidth
                                               multiline
                                    />
                                    {validator.message('excerpt', this.state.excerpt, 'required')}
                                    <div className='text-danger'>{this.state.errors.excerpt}</div>
                                </div>
                            </div>
                            <div className="col-lg-10">
                                <div className="form-group">
                                    <label>Content</label>
                                    <Editor
                                        editorState={this.state.editorState}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                        onEditorStateChange={this.onEditorStateChange}
                                    />
                                    <div className='text-danger'>{this.state.errors.bod}</div>
                                </div>
                            </div>

                            <div className="col-12 text-center">
                                <Button
                                    className="mr-3"
                                    variant="contained"
                                    onClick={() => this.handleGo('/blogs')}
                                >
                                    Batal
                                </Button>
                                {this.state.isManage &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton}
                                >
                                    Tambah{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>
                                }


                            </div>
                        </form>
                    </div>

                </div>
                <ToastContainer />

            </div>
        )
    }
}

export default BlogAdd;
